export default {
    createdAt: "Дата создания",
    txStatus: "Статус транзакции",
    logCashback: "Кешбек токен",
    txAddress: "Адреса",
    txCurrencyCode: "Код токена",
    txHashes: "Хеши",
    setNonce: "Нонс",
    selectedFee: "Лог формирования транзы",
    confirmedTime: "",
    moreInfo: "Подробнее",
    txToken: "Адрес контракта"
}